import styled from "styled-components";
import {
  ChickenNuggetsActionKeys,
  NuggetsType,
  useChickenNuggetsContext,
} from "./ChickenNuggetsContext";
import "../../designTokens/variables.css";

type NuggetType = {
  active: boolean;
  className?: string;
  color: "dark" | "white";
  index: number;
  nugget: NuggetsType;
};

const BaseNugget = ({ className, index, nugget }: NuggetType): JSX.Element => {
  const { dispatch } = useChickenNuggetsContext();

  const handleSetNugget = () => {
    if (nugget.onClick) {
      nugget.onClick(nugget.id);
    }
    dispatch({
      type: ChickenNuggetsActionKeys.ActiveIndex,
      payload: index,
    });
  };

  return <button className={className} onClick={handleSetNugget}></button>;
};

export const Nugget = styled(BaseNugget)`
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  height: 15px;
  width: 15px;
  position: relative;
  padding: 0;

  &:after {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 100%;
    content: "";
    height: 10px;
    width: 10px;
    background: ${(props): string => {
      if (props.color === "dark") {
        return props.active
          ? "var(--color-primary-400)"
          : "var(--color-primary-200)";
      } else {
        return props.active
          ? "var(--color-neutral-000-full)"
          : "var(--color-neutral-000-inactive)";
      }
    }};
  }

  &:hover:after {
    background: ${(props): string => {
      return props.color === "dark"
        ? "var(--color-primary-400)"
        : "var(--color-neutral-000-full)";
    }};
  }
`;
